import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";
import meshImg from "assets/png/footer-cap-mesh.png";
import FooterLogos from "assets/svg/footer-brand-logos.svg";

const Top = styled.div`
  background-image: linear-gradient(to right, #06459f, #33a2df);
  position: relative;
  &:before {
    position: absolute;
    content: "";
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-image: url(${meshImg});
    opacity: 0.5;
  }
  color: ${({ theme }) => theme.palette.white};
  font-weight: bold;
  padding: ${({ theme }) => theme.spacer * 1.5}px;

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: ${({ theme }) => theme.spacer * 1.5}px
      ${({ theme }) => theme.spacer * 4}px;
  }
`;

const Medium = styled.div`
  background-color: ${({ theme }) => theme.palette.grey.darker};
  color: ${({ theme }) => theme.palette.white};
  padding: ${({ theme }) => theme.spacer}px;

  ${({ theme }) => theme.mediaQueries.medium} {
    padding: ${({ theme }) => theme.spacer * 2}px
      ${({ theme }) => theme.spacer * 4}px;
  }
  img {
    height: 1em;
    margin-right: ${({ theme }) => theme.spacer}px;
  }
  a {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.palette.white};
    padding: ${({ theme }) => theme.spacer}px 0;
  }
`;

const Bottom = styled.div`
  display: flex;
  

  background-color: ${({ theme }) => theme.palette.grey.darkest};
  padding: ${({ theme }) => theme.spacer * 2}px ${({ theme }) => theme.spacer}px;
  flex-flow: row wrap;

  .corporate {
    background: url(${FooterLogos}) no-repeat;
    background-position: -300px center;
    background-size: 1000px 30px;
    width: 122px;
    height: 33px;
    margin-right: ${({ theme }) => theme.spacer * 5}px;
    margin-bottom: ${({ theme }) => theme.spacer * 0.5}px;
  }


  ${({ theme }) => theme.mediaQueries.medium} {
    padding: ${({ theme }) => theme.spacer * 3}px
      ${({ theme }) => theme.spacer * 4}px;    

    .corporate {
      margin-bottom: 0;
    }
  }

  a {
    text-indent: -9999px;
  }
`;

const IconWrapper = styled.div`   

  ${({ theme }) => theme.mediaQueries.medium} {
  flex-basis:50%;
  }
`;

const CopyrightWrapper = styled.div`
  width: -webkit-fill-available;  
  margin-top: 25px;  

  ${({ theme }) => theme.mediaQueries.medium} {
    margin-top: 15px;
    flex-basis:50%;
    text-align:left;
  }  

`;

const LinkSection = styled.div`

  display:flex;
  //justify-content: flex-end;
  flex-flow: row wrap;

  ${({ theme }) => theme.mediaQueries.medium} {
    justify-content: flex-end;
  }

  #ot-sdk-btn{
  background: none!important;
  border: none!important;
  padding: 0!important;
  /*optional*/
  font-family: inherit!important;
  /*input has OS specific font-family*/
  color: #fff!important;
  text-decoration: none;
  cursor: pointer;
  float:right;
  font-size: 12px!important;
  &:hover{
    text-decoration: underline;
  }
  }

a, button {
  text-indent: 0;
  float: right;
  font-size: 12px;
  color:#fff;

  margin: 0 10px 0 0;

  ${({ theme }) => theme.mediaQueries.medium} {
    margin: 0 0 0 10px;
  }
  
  

}

`;


const LinksUl = styled.ul`
  display: flex;
  li {
    margin-right: ${({ theme }) => theme.spacer * 2.5}px;
  }
  a {
    background: url(${FooterLogos}) no-repeat;
    background-size: 1000px 30px;
    height: 33px;
    padding: 0;
  }

  .exxon-logo {
    background-position: -600px -1px;
    width: 38px;
  }

  .mobil-logo {
    background-position: -698px 0;
    width: 35px;
  }

  .esso-logo {
    background-position: -798px 0;
    width: 33px;
  }
`;

const Links = ({ list }) => (
  <LinksUl>
    {list.map((l) => (
      <li key={l.name}>
        <a className={l.name} href={l.href} target="_blank" rel="noreferrer">
          {l.name}
        </a>
      </li>
    ))}
  </LinksUl>
);

Links.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      href: PropTypes.string,
    })
  ).isRequired,
};

export { CopyrightWrapper, IconWrapper, Top, Medium, Bottom, Links, LinkSection };
